(function () {
  'use strict';

  angular
    .module('fca-used')
    .service('asyncTasks', asyncTasks);

  asyncTasks.$inject = ['$timeout'];

  function asyncTasks($timeout) {
    var service = {
      push: push,
      pop: pop
    };

    service.count = 0;

    return service;

    function push() {
      $timeout(function () {
        service.count++;
      }, 130);
    }

    function pop() {
      service.count--;
    }
  }
})();
